export const parseJson = <T>(data: string): T | null => {
  let parsedJson = null;

  try {
    parsedJson = JSON.parse(data) as T;
  } catch (error) {
    // do nothing
  }

  return parsedJson;
};

export const parseState = <T>(state: string): T | null => {
  return parseJson<T>(atob(state));
};

export const encodeState = (state: Record<string, string>): string => {
  return btoa(JSON.stringify(state));
};

export const objectsEqual = (a: any, b: any): boolean => {
  // If both are strictly equal or both are NaN
  if (Object.is(a, b)) return true;

  // If types are different, not equal
  if (typeof a !== typeof b) return false;

  // Handle null
  if (a === null || b === null) return a === b;

  // If Array
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!objectsEqual(a[i], b[i])) return false;
    }
    return true;
  }

  // If Date
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // If objects
  if (typeof a === "object" && typeof b === "object" && !Array.isArray(a) && !Array.isArray(b)) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    for (const key of aKeys) {
      if (!b.hasOwnProperty(key)) return false;
      if (!objectsEqual(a[key], b[key])) return false;
    }
    return true;
  }

  // Fallback for primitive types (numbers, strings, booleans, etc.)
  return false;
};
